






























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { addPropertiesIndexed } from '@/store/util';
import { Prop } from 'vue-property-decorator';
import TextInput from '@/components/TextInput.vue';

@Component({
  components: { TextInput },
})
export default class VehicleBox extends Vue {
  static defaultHeight = 7;

  static repeatableStore = 'vehicles';

  static optional = true;

  @Prop(String) readonly itemId: string | undefined;

  created() {
    addPropertiesIndexed(this,
      this.itemId!!,
      'vehicles',
      ['model',
        'handlingStreet',
        'handlingOffroad',
        'armor',
        'body',
        'sensor',
        'pilot',
        'acceleration',
        'seats',
        'speed',
        'topSpeed',
        'notes']);
  }
}
